import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'system';

export const IMAGEKIT_AUTHENTICATION = 'imagekit_authentication';

export const SYSTEM_ENDPOINTS = {
  authenticateImageKit: formatEndpoint(IMAGEKIT_AUTHENTICATION, namespace),
};
